<page-title [title]="title"></page-title>

<mat-form-field appearance="outline" class="search-field">
  <mat-label>Buscar por nome ou CPF</mat-label>
  <input matInput [(ngModel)]="search" (ngModelChange)="applyFilter()" />
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>

<div *ngIf="loading" class="empty-message">Carregando pacientes...</div>
<div *ngIf="!loading && !filteredPatients.length" class="empty-message">Nenhum paciente atendido encontrado.</div>

<div class="patients-grid">
  <mat-card *ngFor="let patient of filteredPatients" class="patient-card" (click)="editPatient(patient)">
    <div>
      <strong>{{ patient.name }}</strong>
      <div class="patient-hint">CPF: {{ patient.cpf || '-' }}</div>
    </div>
    <mat-icon>edit</mat-icon>
  </mat-card>
</div>
